import { z } from 'zod';

export const modalFormSchema = z.object({
  lyrics: z.string().optional(),
  team_uuid: z.string().optional(),
  location: z.string().optional(),
  file: z.any().optional(),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
